import { useNavigate } from "react-router-dom";
import { useShallow } from "zustand/react/shallow";

import { Button } from "@/components/ui/button";
import { getCurrentParticipant } from "@/features/participants/api/get-current-participant";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";
import { cn } from "@/lib/utils";
import { useDroppable } from "@dnd-kit/core";

import { BreakoutSessionParticipant } from "./breakout-session-participant";

export function BreakoutSessionCard({
  name,
  roomKey,
  sessionId,
  disabled = false,
}: {
  name: string;
  roomKey: string;
  sessionId: string;
  disabled?: boolean;
}) {
  const navigate = useNavigate();
  const participants = useVidyoStore(
    useShallow((store) =>
      store.breakoutSession.participants.filter(
        (p) => p.sessionId === sessionId,
      ),
    ),
  );
  const removeParticipant = useVidyoStore(
    (store) => store.breakoutSession.removeParticipant,
  );
  const { isOver, setNodeRef } = useDroppable({
    id: sessionId,
  });

  const handleRoomJoin = async () => {
    //remove myself from the breakout session
    const currentParticipant = getCurrentParticipant();

    if (currentParticipant) {
      removeParticipant(currentParticipant.participantId);
    } else {
      console.error("[handleRoomJoin] Current participant not found");
    }
    navigate(`/r/${roomKey}/call`, { replace: true });
  };

  return (
    <div
      className={cn(
        isOver && "bg-card",
        "space-y-4 rounded-md border border-border p-4",
      )}
      ref={setNodeRef}
    >
      <p className="flex text-sm text-foreground">
        {name}
        <span className="ml-auto text-muted-foreground">
          {participants.length}
        </span>
      </p>

      <div className="flex flex-wrap gap-2">
        {participants.map((p) => (
          <BreakoutSessionParticipant key={p.participantId} participant={p} />
        ))}
      </div>

      {!disabled && (
        <Button variant="outline" onClick={handleRoomJoin}>
          Join
        </Button>
      )}
    </div>
  );
}
